import Vue from 'vue'
import App from './App'
import router from '@/router'
import store from '@/store'
import raf from '@/plugins/raf'
import filters from '@/plugins/filters'
import api from '@/plugins/api'
import tools from '@/plugins/tools'
import scroll from '@/plugins/scroll'

import { Howl, Howler } from 'howler';

// import 'babel-polyfill'
import "core-js"
import 'dom-shims'
import "@fortawesome/fontawesome-pro/css/all.css"

import VueCookie from 'vue-cookie'
import VueHead from 'vue-head'
import VueAnalytics from 'vue-analytics'

Vue.use(raf)
Vue.use(tools)
Vue.use(scroll)
Vue.use(api)

Vue.config.productionTip = true

Vue.use(VueCookie)
Vue.use(tools)
Vue.use(scroll)
Vue.use(VueHead)

Vue.use(VueAnalytics, {
  id: 'UA-68930534-15',
  router
})

// Get global data before first launch
// router.beforeEach((to, from, next) => {
//   Vue.$api.getData()
//   .then(response => {
//     console.log('getData', response.data)
//     store._actions.setGlobalData[0](response.data)
//     next()
//   })
// })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#Site')
